import { Box, Modal, Grid, Zoom, Checkbox, FormControlLabel, TextField, RadioGroup, Stack } from '@mui/material';
import { BackdropLoading } from '../../../shared/spinner/backdropLoading';
import { useDelayedEffect } from '../../../shared/delayedEffect/useDelayedEffect';
import { CancelButton, CheckBoxContainer, ModalLabel, modalStyle, OkButton, OperatorRadio, TextFieldForm, TextFieldLabel } from './torihikiginkoCondition.styles';
import React, { useRef } from 'react';
import { sessionDisconnectedCheck } from '../../../shared/api/sessionDisconnectedCheck';
import { fetchAuthSession } from 'aws-amplify/auth';
import { SearchCrudApiRequest } from '../../../shared/model/apiRequestModel';
import crud from '../../../shared/api/crud';
import { SystemErrorMsg, SystemErrorTitle } from '../../../constants';
import { useNavigate } from 'react-router-dom';
import { KinyuInfoListContainer, ShitenInfoListContainer } from './checkBoxCompornent';

interface OwnProps {
    isOpen: boolean,
    handleClose: (isOpen: boolean) => void
    handleOk: (value: DialogItemType[], operator: string) => void,
}

interface DialogItemType {
    id: string
    value: string
}

interface KinyuInfo {
    kinyuId: string
    kinyuValue: string
}

interface ShitenInfo {
    kinyuId: string
    shitenId: string
    shitenValue: string
}

interface CheckCode {
    kinyu: Set<string>
    shiten: Set<string>
}

interface SearchHidden {
    kinyu: Set<string>
    shiten: Set<string>
}

const screenId = "U045"

const TorihikiginkoDialog = (props: OwnProps) => {
    const navigate = useNavigate();
    const { isOpen, handleClose } = props
    const [open, setOpen] = React.useState(isOpen);
    const [operator, setOperator] = React.useState('or');
    const [kinyuInfoList, setKinyuInfoList] = React.useState<KinyuInfo[]>([]);
    const [shitenInfoList, setShitenInfoList] = React.useState<ShitenInfo[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [error, setError] = React.useState(false)
    const [kinyuKeyword, setKinyuKeyword] = React.useState('')
    const [shitenKeyword, setShitenKeyword] = React.useState('')
    const idRef = useRef(0);

    //チェック状態管理
    const [checkCode, setCheckCode] = React.useState<CheckCode>({ kinyu: new Set(), shiten: new Set() });

    //キーワード検索状態管理
    const [searchHidden, setSearchHidden] = React.useState<SearchHidden>({ kinyu: new Set(), shiten: new Set() });

    const getKinyuInfoList = async () => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "getKinyuInfoList", navigate)) {
            return
        }
        setLoading(true)
        const session = await fetchAuthSession();
        const email = session.tokens?.idToken?.payload?.email?.toString() || '';
        const sessionId = session.tokens?.idToken?.payload?.sessionId?.toString() || '';
        const accountInfoData = JSON.parse(session.tokens?.idToken?.payload?.accountInfoData?.toString() || "[]");
        const contract = JSON.parse(session?.tokens?.idToken?.payload.contractInfoData?.toString() || "[]");
        const contractForm = contract.length !== 0 && contract[0].contractForm;
        const request: SearchCrudApiRequest = {
            sessionId: sessionId,
            userMailAddress: email,
            processFlag: "0",
            countFlag: "0",
            contractForm: contractForm,
            targetTableName: 'M_GINKO',
            selectItems: ['GNKCDKNYKKN', 'GNKMKNJ'],
            conditions: [
                {
                    targetColumn: "GNZN_FLG",
                    targetValue: ["1"]
                },
                {
                    targetColumn: "GNKCDTNP",
                    targetValue: ["000"]
                }
            ],
            conditionsOperator: 'and',
            orderBy: [
                {
                    sortColumn: 'GNKCDKNYKKN',
                    sortRule: 'ASC',
                }
            ],
            usingStartDate: contract.length !== 0 && accountInfoData[0].usingStartDate
        }
        const response = crud(request);
        const resCd = (await response).resCd;
        if (resCd === 'I0000') {
            const codeList: KinyuInfo[] = (await response).data?.resultData.map((item: { GNKCDKNYKKN: string; GNKMKNJ: string; }) => {
                return { kinyuId: item.GNKCDKNYKKN, kinyuValue: item.GNKMKNJ }
            })
            setKinyuInfoList(codeList);
            setLoading(false);
        } else {
            navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
        }
    };

    const getShitenInfoList = async (kinyuId: string, currentId: number) => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "getShitenInfoList", navigate)) {
            return
        }
        setLoading(true)
        const session = await fetchAuthSession();
        const email = session.tokens?.idToken?.payload?.email?.toString() || '';
        const sessionId = session.tokens?.idToken?.payload?.sessionId?.toString() || '';
        const accountInfoData = JSON.parse(session.tokens?.idToken?.payload?.accountInfoData?.toString() || "[]");
        const contract = JSON.parse(session?.tokens?.idToken?.payload.contractInfoData?.toString() || "[]");
        const contractForm = contract.length !== 0 && contract[0].contractForm;
        const request: SearchCrudApiRequest = {
            sessionId: sessionId,
            userMailAddress: email,
            processFlag: "0",
            countFlag: "0",
            contractForm: contractForm,
            targetTableName: 'M_GINKO',
            selectItems: ['GNKCDKNYKKN', 'GNKCDTNP', 'GNKTNPMKNJ'],
            conditions: [
                {
                    targetColumn: "GNKCDKNYKKN",
                    targetValue: [kinyuId]
                },
                {
                    targetColumn: "GNZN_FLG",
                    targetValue: ["1"]
                }
            ],
            conditionsOperator: 'and',
            orderBy: [
                {
                    sortColumn: 'GNKCDKNYKKN',
                    sortRule: 'ASC',
                },
                {
                    sortColumn: 'GNKCDTNP',
                    sortRule: 'ASC',
                }
            ],
            usingStartDate: contract.length !== 0 && accountInfoData[0].usingStartDate
        }
        const response = crud(request);
        const resCd = (await response).resCd;
        if (resCd === 'I0000') {
            const codeList: ShitenInfo[] = (await response).data?.resultData.map((item: { GNKCDKNYKKN: string; GNKCDTNP: string; GNKTNPMKNJ: string; }) => {
                return { kinyuId: item.GNKCDKNYKKN, shitenId: item.GNKCDTNP, shitenValue: item.GNKTNPMKNJ }
            })
            setLoading(false);
            if (currentId !== idRef.current) return;
            setShitenInfoList(codeList.filter((v: ShitenInfo) => v.shitenId !== "000"));
        } else {
            navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
        }
    };

    React.useEffect(() => {
        if (isOpen) {
            setError(false);
            setOperator('or');
            setKinyuKeyword('');
            setShitenKeyword('');
            setCheckCode({ kinyu: new Set(), shiten: new Set() });
            setSearchHidden({ kinyu: new Set(), shiten: new Set() });
            if (kinyuInfoList.length === 0) {
                getKinyuInfoList()
            }
        }
        setOpen(isOpen)
    }, [isOpen])

    //金融機関でチェックされたアイテム
    const checkedKinyu = React.useMemo(() => {
        return kinyuInfoList.filter((x) => checkCode.kinyu.has(x.kinyuId))
    }, [checkCode.kinyu]);

    //支店表示条件
    React.useEffect(() => {
        const currentId = ++idRef.current;
        if (checkedKinyu.length !== 1) {
            setCheckCode({ ...checkCode, shiten: new Set() })
            setShitenInfoList([])
        } else {
            // チェックが1つだけの場合は支店を取得する
            getShitenInfoList(checkedKinyu[0].kinyuId, currentId)
        }
    }, [checkedKinyu]);

    const toggleKinyu = React.useCallback((kinyuId: string) => {
        setCheckCode((prev) => {
            const next = new Set(prev.kinyu);
            if (next.has(kinyuId)) next.delete(kinyuId);
            else next.add(kinyuId);
            return { ...prev, kinyu: next };
        });
    }, []);

    const toggleShiten = React.useCallback((shitenId: string) => {
        setCheckCode((prev) => {
            const next = new Set(prev.shiten);
            if (next.has(shitenId)) next.delete(shitenId);
            else next.add(shitenId);
            return { ...prev, shiten: next };
        });
    }, []);

    const handleOk = async () => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "torihikiginkoHandleOk", navigate)) {
            return
        }
        const checkedKinyuItems: DialogItemType[] = [];
        const checkedShitenItems: DialogItemType[] = [];
        for (const x of kinyuInfoList) if (checkCode.kinyu.has(x.kinyuId)) checkedKinyuItems.push({ id: x.kinyuId, value: x.kinyuValue });
        for (const x of shitenInfoList) if (checkCode.shiten.has(x.shitenId)) checkedShitenItems.push({ id: x.kinyuId + x.shitenId, value: checkedKinyuItems[0].value + ' ' + x.shitenValue });
        if (checkedKinyuItems.length === 0 && checkedShitenItems.length === 0) {
            setError(true);
        } else if (checkedShitenItems.length === 0) {
            props.handleOk(checkedKinyuItems, operator)
        } else {
            props.handleOk(checkedShitenItems, operator)
        }
    }

    useDelayedEffect(
        () => {
            kinyuInfoList.forEach((info) => {
                if (info.kinyuValue.includes(kinyuKeyword)) {
                    setSearchHidden((prev) => {
                        const next = new Set(prev.kinyu);
                        next.delete(info.kinyuId);
                        return { ...prev, kinyu: next };
                    });
                } else {
                    setSearchHidden((prev) => {
                        const next = new Set(prev.kinyu);
                        next.add(info.kinyuId);
                        return { ...prev, kinyu: next };
                    });
                }
            });
        },
        [kinyuKeyword],
        750,
    )

    useDelayedEffect(
        () => {
            shitenInfoList.forEach((info) => {
                if (info.shitenValue.includes(shitenKeyword)) {
                    setSearchHidden((prev) => {
                        const next = new Set(prev.shiten);
                        next.delete(info.shitenId);
                        return { ...prev, shiten: next };
                    });
                } else {
                    setSearchHidden((prev) => {
                        const next = new Set(prev.shiten);
                        next.add(info.shitenId);
                        return { ...prev, shiten: next };
                    });
                }
            });
        },
        [shitenKeyword],
        750,
    )

    return (
        <>
            <BackdropLoading open={loading} />
            <Modal
                open={open}
                onClose={handleClose}
                closeAfterTransition
                sx={{
                    zIndex: 900
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            zIndex: 900
                        }
                    }
                }}
            >
                <Zoom
                    in={open}
                    style={{ zIndex: 1000, transformOrigin: '-50% -50% -50%' }}
                    easing={{
                        enter: "cubic-bezier(0, 1.45, 0.62, 1)",
                        exit: "linear"
                    }}
                >
                    <Box sx={modalStyle} tabIndex={-1}>
                        <ModalLabel>
                            選択条件 - 取引銀行
                        </ModalLabel>
                        <Stack direction={"row"} marginTop={1} >
                            <Box marginLeft={3} alignContent='center'>
                                <RadioGroup row value={operator} onChange={e => setOperator(e.target.value)} >
                                    <FormControlLabel value="and" control={<OperatorRadio />} label="AND" />
                                    <FormControlLabel value="or" control={<OperatorRadio />} label="OR" />
                                </RadioGroup>
                            </Box>
                            {
                                error ?
                                    <Box alignContent='center' marginLeft={3} sx={{ color: 'red', fontSize: '1.2rem' }}>   条件を一つ以上選択してください</Box>
                                    :
                                    <></>
                            }
                        </Stack>
                        <Box p={1} marginBottom={1}>
                            <Grid container justifyContent="center" columnGap={1}>
                                <Grid container size={5.9}>
                                    <TextFieldLabel width='39%'>金融機関名</TextFieldLabel>
                                    <TextFieldForm width='60%'>
                                        <TextField fullWidth variant='outlined' value={kinyuKeyword} size='small' onChange={(event) => setKinyuKeyword(event.target.value)} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderRadius: '0px' } }} />
                                    </TextFieldForm>
                                    <KinyuInfoListContainer kinyuInfoList={kinyuInfoList} searchHidden={searchHidden.kinyu} checkCode={checkCode.kinyu} toggleKinyu={toggleKinyu} >
                                    </KinyuInfoListContainer>
                                </Grid>
                                <Grid container size={5.9}>
                                    <TextFieldLabel width='39%'>支店名</TextFieldLabel>
                                    <TextFieldForm width='60%'>
                                        <TextField fullWidth variant='outlined' value={shitenKeyword} size='small' onChange={(event) => setShitenKeyword(event.target.value)} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderRadius: '0px' } }} />
                                    </TextFieldForm>
                                    <ShitenInfoListContainer shitenInfoList={shitenInfoList} searchHidden={searchHidden.shiten} checkCode={checkCode.shiten} toggleShiten={toggleShiten}>
                                    </ShitenInfoListContainer>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box p={2} sx={{ marginTop: '-3%', marginBottom: '1%' }}>
                            <Grid container sx={{ width: '98%' }}>
                                <Grid size={7} />
                                <Grid size={5}>
                                    <CancelButton variant="contained" onClick={() => handleClose(false)}>キャンセル</CancelButton>
                                    <OkButton variant="contained" onClick={() => handleOk()}>OK</OkButton>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Zoom>
            </Modal >
        </>
    );
}

export default TorihikiginkoDialog;
